import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-biq-button',
  imports: [
    CommonModule,
  ],
  templateUrl: './biq-button.component.html',
  styleUrl: './biq-button.component.css'
})
export class BiqButtonComponent implements OnChanges {
  @Input() name: string = 'Continue';
  @Input() loader = false;
  @Output() buttonEmitter = new EventEmitter<void>();

  private liveAnnouncer = inject(LiveAnnouncer);
  private wasLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loader']) {
      const isLoading = changes['loader'].currentValue;
      if (isLoading && !this.wasLoading) {
        this.liveAnnouncer.announce('Loading, please wait…', 'polite');
      } else if (!isLoading && this.wasLoading) {
        this.liveAnnouncer.announce('Loading complete.', 'polite');
      }
      this.wasLoading = isLoading;
    }
  }

  onClickBtn() {
    this.buttonEmitter.emit();
  }
}
